import React from 'react';
import classnames from 'classnames';
import Base from './Base';


const SecondaryButton = ({className, ...props}) => <Base {...props} className={classnames('btn--secondary btn--bordered', className)} />;

export default SecondaryButton;
